export const withLineBreaks = (data: string) => {
    return data.split('\r\n').map((str, index)  => <div key={index}>{str}</div>);
}